<mat-card class="summary-card ytd-total">
    <div class="summary-title ytd-total">YEAR TO DATE (Up till yesterday)</div>
    <div class="summary-content">
        <div class="summary-metric">
            <span class="metric-label">SALES</span>
            <span class="metric-value">{{ yearToDateSalesTop | currency:'USD':'symbol':'1.0-0' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateSalesBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">LABOUR %</span>
            <span class="metric-value">{{ yearToDateLabourPerTop }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateLabourPerBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">ONLINE SALES</span>
            <span class="metric-value">{{ yearToDateOnlineSalesTop | currency:'USD':'symbol':'1.0-0' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateOnlineSalesBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">ONLINE CUSTOMER ORDERS</span>
            <span class="metric-value">{{ yearToDateOnlineCustomerOrdersTop | number:'1.0-0' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateOnlineCustomerOrdersBottom"></span>
        </div>
        @if (this.shopType!="DT") {
        <div class="summary-metric">
            <span class="metric-label">DRIVE-THRU SALES</span>
            <span class="metric-value">{{ yearToDateDtSalesTop | currency:'USD':'symbol':'1.0-0' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateDtSalesBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">DRIVE-THRU ORDERS</span>
            <span class="metric-value">{{ yearToDateDtSalesCountTop | number:'1.0-0' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateDtSalesCountBottom"></span>
        </div>
        }
        <div class="summary-metric">
            <span class="metric-label">TARGET</span>
            <span class="metric-value">{{ yearToDateTargetTop | currency:'USD':'symbol':'1.0-0' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateTargetBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">LABOUR HOURS</span>
            <span class="metric-value">{{ yearToDateLabourHoursTop | number:'1.0-0'}}</span>
            <span class="metric-sub" [innerHTML]="yearToDateLabourHoursBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">CUSTOMER ORDERS</span>
            <span class="metric-value">{{ yearToDateCustomerOrdersTop | number:'1.0-0'}}</span>
            <span class="metric-sub" [innerHTML]="yearToDateCustomerOrdersBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">LABOUR COST</span>
            <span class="metric-value">{{ yearToDateLabourCostTop | currency:'USD':'symbol':'1.0-0'}}</span>
            <span class="metric-sub" [innerHTML]="yearToDateLabourCostBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">ITEM SOLD</span>
            <span class="metric-value">{{ yearToDateItemsSoldTop | number:'1.0-0' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateItemsSoldBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">SALES / LABOUR HOUR</span>
            <span class="metric-value">{{ yearToDateSalesByLabourHourTop | currency:'USD':'symbol':'1.2-2' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateSalesByLabourHourBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">SALES VALUE / ITEM</span>
            <span class="metric-value">{{ yearToDateSalesValueByItemTop | currency:'USD':'symbol':'1.2-2' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateSalesValueByItemBottom"></span>
        </div>
        <div class="summary-metric">
            <span class="metric-label">AVERAGE ORDER $</span>
            <span class="metric-value">{{ yearToDateAverageOrderTop | currency:'USD':'symbol':'1.2-2' }}</span>
            <span class="metric-sub" [innerHTML]="yearToDateAverageOrderBottom"></span>
        </div>
    </div>
</mat-card>